'use client';

import { useEffect, useRef } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export type EditableStatePluginProps = {
  /**
   * Indicates if the editor should be disabled (non-editable).
   */
  disabled?: boolean;
};

/**
 * Plugin component that updates the editor's editable state when disabled prop changes
 */
export function EditableStatePlugin({
  disabled = false,
}: EditableStatePluginProps) {
  const [editor] = useLexicalComposerContext();
  const previousDisabledRef = useRef<boolean>(disabled);

  useEffect(() => {
    // Only update if the disabled state actually changed
    if (previousDisabledRef.current !== disabled) {
      previousDisabledRef.current = disabled;
      editor.setEditable(!disabled);
    }
  }, [editor, disabled]);

  return null;
}
